// Client-side public surface: what other modules may use.

import { lazyView } from "@/platform/client";

export const CalendarPage = lazyView(() =>
  import("./ui/calendar/CalendarPage.js").then((m) => m.CalendarPage),
);
export { EventModal } from "./ui/components/EventModal.js";
export { TaskModal } from "./ui/components/TaskModal.js";
export { buildDayEventMap } from "./ui/lib/events.js";
export { useCalendars, useEvents } from "./ui/queries/calendar.js";

export { useTasks, useUpdateTask } from "./ui/queries/tasks.js";
export const TasksPage = lazyView(() => import("./ui/tasks/TasksPage.js").then((m) => m.TasksPage));

export { DefaultImportCalendarRow } from "./ui/settings/DefaultImportCalendarRow.js";
export { HolidaySettings } from "./ui/settings/HolidaySettings.js";
export { calendarNotifications } from "./ui/notifications.js";
